import React, { useState } from 'react';
import { getPath } from '../../utils/getPath';
import { Grid, Box, useTheme, useMediaQuery, makeStyles, Typography, Button } from '@material-ui/core';
import PageSubTitle from '../UI/PageSubTitle';
import ReqForm1 from './ReqForm1';
import ReqForm2 from './ReqForm2';

const RequestForms = () => {
    const theme = useTheme();
    const isMD = useMediaQuery(theme.breakpoints.down('md'));
    const classes = useStyles();
    const [openform1, setOpenform1] = useState(false);
    const [openform2, setOpenform2] = useState(false);

    return (
        <Box mb={10}>
            <Grid container spacing={isMD ? 3 : 5}>
                <Grid item xs={12} md={6}>
                    <Box className={classes.card}>
                        <Box minHeight={130} mb={3}>
                            <img src={getPath('public/img/req_card_icon_1.svg')} alt="" />
                        </Box>
                        <Box flex={1}>
                            <PageSubTitle>Не нашли нужную технику?</PageSubTitle>
                        </Box>
                        <Box mb={3}>
                            <Typography variant="body2">
                                Запросите её у Вашего менеджера! Отправьте заявку, менеджер перезвонит Вам в ближайшее время
                            </Typography>
                        </Box>
                        <Button variant="outlined" color="primary" onClick={() => setOpenform1(true)}>
                            отправить заявку
                        </Button>
                    </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Box className={classes.card}>
                        <Box minHeight={130} mb={3}>
                            <img src={getPath('public/img/req_card_icon_2.svg')} alt="" />
                        </Box>
                        <Box flex={1}>
                            <PageSubTitle>Есть сложная задача?</PageSubTitle>
                        </Box>
                        <Box mb={3}>
                            <Typography variant="body2">
                                Запросите её у Вашего менеджера! Отправьте заявку, менеджер перезвонит Вам в ближайшее время
                            </Typography>
                        </Box>
                        <Button variant="outlined" color="primary" onClick={() => setOpenform2(true)}>
                            хочу решение
                        </Button>
                    </Box>
                </Grid>
            </Grid>

            <ReqForm1 open={openform1} onClose={() => setOpenform1(false)} />
            <ReqForm2 open={openform2} onClose={() => setOpenform2(false)} />
        </Box>
    );
};

const useStyles = makeStyles(theme => ({
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        textAlign: 'center',
        padding: theme.spacing(5),
        border: '1px solid #ececec',
    },
}));

export default RequestForms;
